/* eslint-disable */
import React, {Component} from "react";
import {mesAutobind} from "@posco/posco-shared";
import {Common} from "@plm/o10-share-front";
import {DataGrid, Modal} from "@posco/posco-ui-react";
import O10g014112Container from "../../o10g014112/container/O10g014112Container";


@mesAutobind
class o10g014111View extends Component {
  state = {
    view4112: false,
    modal: false,
    title: "",
    columnDefs:
      [
        {
          headerName: "사업접수번호",
          field: "bizRegCode"
        }, {
        headerName: "투자코드",
        field: "projectNumber"
      }, {
        headerName: "사업명",
        field: "investmetRegistNm",
        cellStyle: {textAlign: "left"}
      }, {
        headerName: "요청일",
        field: "confirmDate",
        valueGetter: (param) => param.data.confirmDate && param.data.confirmDate.slice(0, 10)
      }, {
        headerName: "승인일",
        field: "apprDate",
        valueGetter: (param) => param.data.apprDate && param.data.apprDate.slice(0, 10)

      }, {
        headerName: "준공일",
        field: "investBizCompletionDate",
        valueGetter: (param) => param.data.investBizCompletionDate && param.data.investBizCompletionDate.slice(0, 10)

      }, {
        headerName: "완료일",
        field: "endDate",
        valueGetter: (param) => param.data.endDate && param.data.endDate.slice(0, 10)

      }, {
        headerName: "역할자명",
        field: "roleNm",
        cellStyle: {textAlign: "left"}
      }, {
        headerName: "PA등록구분",
        field: "inpTp"
      }, {
        headerName: "누적기간",
        field: "term",
        cellStyle: {textAlign: "right"}
      }
      ]
  };

  componentDidMount() {
    Common.InitUtil.init("o10g014111");
  }

  toggleView4112() {
    this.setState({view4112: !this.state.view4112});
  }

  handleModal(value, type, title) {
    if (value) {
      this.setState({modal: value, title: title});
    } else {
      this.setState({modal: !this.state.modal, title: ""});
    }
    if (type) this.props.onInvbpInfoFindDetail(type);
  }

  render() {
    const triggerList = [
      {size: "small"}
    ];

    const {tabInfo} = this.state;
    return (
      <>

        <div className="profileCont">
          <p>나의 사업수행이력</p>
          <div className="profileTop">
            <div className="pfTopLeft">
              <div className="pfImgWrap">
                <div className="pfImg">
                  {this.props.userInfo && this.props.userInfo.profile &&
                    <img
                      src={this.props.userInfo.profile.includes(`res/media`) ? this.props.userInfo.profile : `o10g01-invcommon/aws/profile/${this.props.userInfo.profile}`}/>
                  }
                </div>
                {/*설정버튼*/}
                <button onClick={this.toggleView4112}/>
                {this.state.view4112 &&
                  <O10g014112Container
                    open={this.state.view4112}
                    openToggle={this.toggleView4112}
                    userInfo={this.props.userInfo}
                    onUserInfoFind={this.props.onUserInfoFind}
                  />
                }
              </div>
              <p>{Common.PotalUtil.getStorageItem("Posco.auth.userInfo").employeeName}</p>
            </div>
            <div className="pfTopRight">
              <a onClick={() => Common.PotalUtil.addPotalTab("/o10t01-front/o10g01-front/o10g015440")}>
                <div>
                  <div className="newIcon">
                    {this.props.invpInfo && this.props.invpInfo.A && Number(this.props.invpInfo.A.cnt) ?
                      <span>N</span> : null
                    }
                  </div>
                  <span className="Table_fontB">결재요청</span>
                </div>
                <span>{this.props.invpInfo && this.props.invpInfo.A && this.props.invpInfo.A.cnt.toLocaleString() || 0}건</span>
              </a>
              <a onClick={() => this.handleModal(true, 1, "제안")}>
                <p>
                  <span className="Table_fontB">제안</span>
                </p>
                <p>
                <span
                  className="floatR">{this.props.invpInfo && this.props.invpInfo.A && this.props.invpInfo.T1.cnt.toLocaleString() || 0}건</span>
                </p>
              </a>
              <a onClick={() => this.handleModal(true, 2, "설계")}>
                <p>
                  <span className="Table_fontB">설계</span>
                </p>
                <p>
                <span
                  className="floatR">{this.props.invpInfo && this.props.invpInfo.A && this.props.invpInfo.T2.cnt.toLocaleString() || 0}건</span>
                </p>
              </a>
              <a onClick={() => this.handleModal(true, 3, "CM")}>
                <p>
                  <span className="Table_fontB">CM</span>
                  <span
                    className="floatR">{this.props.invpInfo && this.props.invpInfo.A && this.props.invpInfo.T3.cnt.toLocaleString() || 0}건</span>
                </p>
                <p>
                <span
                  className="floatR">누적 {this.props.invpInfo && this.props.invpInfo.A && this.props.invpInfo.T3.days.toLocaleString() || 0}년</span>
                </p>
              </a>
              <a onClick={() => this.handleModal(true, 4, "PM")}>
                <p>
                  <span className="Table_fontB">PM</span>
                  <span
                    className="floatR">{this.props.invpInfo && this.props.invpInfo.A && this.props.invpInfo.T4.cnt.toLocaleString() || 0}건</span>
                </p>
                <p>
                <span
                  className="floatR">누적 {this.props.invpInfo && this.props.invpInfo.A && this.props.invpInfo.T4.days.toLocaleString() || 0}년</span>
                </p>
              </a>
            </div>
          </div>

          <hr/>
          <div className="profileBottom">
            <button>
              <div/>
              <p>계획<span>{this.props.invpInfo && this.props.invpInfo.B && this.props.invpInfo.B.revCnt.toLocaleString() || 0}건</span>
              </p>
            </button>
            <button>
              <div/>
              <p>진행<span>{this.props.invpInfo && this.props.invpInfo.B && this.props.invpInfo.B.appCnt.toLocaleString() || 0}건</span>
              </p>
            </button>
            <button>
              <div/>
              <p>준공<span>{this.props.invpInfo && this.props.invpInfo.B && this.props.invpInfo.B.comCnt.toLocaleString() || 0}건</span>
              </p>
            </button>
            <button>
              <div/>
              <p>완료<span>{this.props.invpInfo && this.props.invpInfo.B && this.props.invpInfo.B.relCnt.toLocaleString() || 0}건</span>
              </p>
            </button>
          </div>
        </div>
        {/* 사업정보 디테일 모달 */}
        <Modal open={this.state.modal} onClose={() => this.handleModal(false)} size={"fullscreen"}>
          <Modal.Header content={this.state.title}/>
          <Modal.Content>
            <div className="ag-theme-raylab" style={{width: "100%"}}>
              <DataGrid
                columnDefs={this.state.columnDefs}
                defaultColDef={{resizable: true}}
                rowData={this.props.invpInfoDetail && this.props.invpInfoDetail.Detail || []}
                onGridReady={this.onGridReady}
                headerHeight={34}
                rowHeight={30}
                minHeight={150}
                maxHeight={400}
              />
            </div>
          </Modal.Content>
        </Modal>
      </>
    );
  }
}

export default o10g014111View;
